export const DRAWER_WIDTH: number = 200;
export const POPOVER_HEADER_HEIGHT: number = 78;
export const HEADER_HEIGHT: number = 73;
export const APP_PAPER_WIDTH: number = 219;
export const APP_PAPER_HEIGHT: number = 244;
export const APP_PAPER_MARGIN: number = 16;
export const MENU_ITEM_HEIGHT: number = 60;
